import { render } from "./CapacityDashboard.vue?vue&type=template&id=66553ec3&scoped=true"
import script from "./CapacityDashboard.vue?vue&type=script&lang=js"
export * from "./CapacityDashboard.vue?vue&type=script&lang=js"

import "./CapacityDashboard.vue?vue&type=style&index=0&id=66553ec3&lang=less&scoped=true"

import exportComponent from "/root/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66553ec3"]])

export default __exports__